import React, { useState, useMemo, useEffect } from 'react';
import Chart from "react-google-charts";
import { fetchData } from '../../common/networkRequests';


// Options are same as https://developers.google.com/




const GoogleChart = (props) => {

  let { values, showvalues, ddType, dformat } = props.component;
  let { selectedTourBranch } = props.parentState.LocalVars;
  let [dashboarddata, setdashboarddata] = useState([]);
  let [loading, setloading] = useState(false);


  const setDashData = (alldata) => {


    const dataOld = [
      ["Observations", "Compliance"]
    ];

    const dataNew = [
      ["Observations", "Compliance"]
    ];



    console.log({ GOOGLEDATA: alldata })
    // setdashboarddata(alldata.results);
    let chartData = [['Observations', 'Incomplete', 'Completed']];
    alldata.results.map(({ display_name, total, completed }) => {
      // chartData.push([display_name, total - completed, completed])

      dataOld.push([display_name, total]);
      dataNew.push([display_name, completed]);

    });

    const diffdata = {
      old: dataOld,
      new: dataNew,
    };
    // console.log({ chartData })

    setdashboarddata(diffdata);

    setloading(false);
  }

  const getLatestData = (selectedTourBranch) => {
    let method = 'post';
    let pd = { gui: "dashboard" };
    if (selectedTourBranch) {
      pd['branch_uid'] = selectedTourBranch.value;

    }
    let saveThis = { dataType: "search", pageData: pd, currentPage: ddType };
    console.log({ ddType })
    if (ddType) {
      setloading(true);
      fetchData({ url: 'cbsurl', postData: saveThis, method, current: { props }, cbf: setDashData });
    }
  }
  useMemo(() => getLatestData(selectedTourBranch), [selectedTourBranch]);





  let { charttype, widths } = props.component;



  return (
    <div className={`form-group col-sm-12 `}>

      {charttype == 'bar' &&
        <Chart
          chartType="ColumnChart"
          width="100%"
          height="400px"
          diffdata={dashboarddata}
          options={{
            legend: { position: 'bottom' },

          }}
        />
      }

      {charttype == 'castebar' &&
        <Chart
          width={'100%'}
          height={'250px'}
          chartType="Bar"
          loader={<div>Loading Chart</div>}
          data={[
            ['Quarter', 'Niradhar', 'NCF', 'Other'],
            ['March 21', 22, 44, 12],
            ['June 21', 16, 29, 8],
            ['September 21', 11, 30, 8],
            ['December 21', 7, 24, 9],
          ]}
          options={{
            // Material design options
            chart: {
              title: 'Disbursements Performance',
              subtitle: 'March 2021 - December 2021',
            },
          }}
          // For tests
          rootProps={{ 'data-testid': '2' }}
        />
      }

      {charttype == 'pie1' &&
        <Chart
          width={'100%'}
          height={'250px'}
          chartType="PieChart"
          loader={<div>Loading Chart</div>}
          data={[
            ['Taluka', 'Amount'],
            ['Parbhani', 17],
            ['Pathri', 12],
            ['Manwat', 5],
            ['Hingoli', 21],
            ['Aundha', 6]
          ]}
          options={{
            title: 'Current Month',
          }}
          rootProps={{ 'data-testid': '1' }}
        />
      }
      {charttype == 'pie3' &&
        <Chart
          width={'100%'}
          height={'250px'}
          chartType="PieChart"
          loader={<div>Loading Chart</div>}
          data={[
            ['Gender', 'Amount'],
            ['Male', 198],
            ['Female', 139],
            ['Other', 1]
          ]}
          options={{
            title: 'Current Month',
          }}
          rootProps={{ 'data-testid': '1' }}
        />
      }


      {charttype == 'timeline' &&
        <Chart
          width={'100%'}
          height={'250px'}
          chartType="Timeline"
          loader={<div>Loading Chart</div>}
          data={[
            [
              { type: 'string', id: 'Position' },
              { type: 'string', id: 'Name' },
              { type: 'date', id: 'Start' },
              { type: 'date', id: 'End' },
            ],
            [
              'Ambala',
              'Started',
              new Date(2021, 9, 12),
              new Date(2021, 9, 12),
            ],
            [
              'Ambala',
              'Trial Balance',
              new Date(2021, 9, 13),
              new Date(2021, 9, 13),
            ],


            [
              'Bhiwani',
              'Uploaded',
              new Date(2021, 9, 1),
              new Date(2021, 9, 11),
            ],
            [
              'Bhiwani',
              'Verified',
              new Date(2021, 9, 11),
              new Date(2021, 9, 19),
            ],
            [
              'Bhiwani',
              'Finalized',
              new Date(2021, 9, 19),
              new Date(2021, 9, 26),
            ],
            [
              'Bhiwani',
              'Accepted',
              new Date(2021, 9, 26),
              new Date(2021, 9, 27),
            ],

            [
              'Faridabad',
              'Uploaded',
              new Date(2021, 9, 21),
              new Date(2021, 9, 28),
            ],
            [
              'Faridabad',
              'Verified',
              new Date(2021, 9, 28),
              new Date(2021, 10, 10),
            ],
            [
              'Faridabad',
              'Finalized',
              new Date(2021, 10, 10),
              new Date(2021, 10, 14),
            ],
            [
              'Faridabad',
              'Accepted',
              new Date(2021, 10, 14),
              new Date(2021, 10, 15),
            ],



            [
              'Fatehabad',
              'Uploaded',
              new Date(2021, 9, 1),
              new Date(2021, 9, 11),
            ],
            [
              'Fatehabad',
              'Verified',
              new Date(2021, 9, 11),
              new Date(2021, 9, 18),
            ],
            [
              'Fatehabad',
              'Finalized',
              new Date(2021, 9, 18),
              new Date(2021, 9, 24),
            ],
            [
              'Fatehabad',
              'Accepted',
              new Date(2021, 9, 24),
              new Date(2021, 9, 25),
            ],

            [
              'Gurgaon',
              'Uploaded',
              new Date(2021, 9, 1),
              new Date(2021, 9, 4),
            ],
            [
              'Gurgaon',
              'Verified',
              new Date(2021, 9, 2),
              new Date(2021, 9, 7),
            ],
            [
              'Gurgaon',
              'Finalized',
              new Date(2021, 9, 5),
              new Date(2021, 9, 18),
            ],
            [
              'Gurgaon',
              'Accepted',
              new Date(2021, 9, 18),
              new Date(2021, 9, 19),
            ],


          ]}
          rootProps={{ 'data-testid': '3' }}
        />
      }




      {charttype == 'gantt' &&

        <Chart
          width={'100%'}
          height={'250px'}
          chartType="Gantt"
          loader={<div>Loading Chart</div>}
          data={[
            [
              { type: 'string', label: 'Task ID' },
              { type: 'string', label: 'Task Name' },
              { type: 'date', label: 'Start Date' },
              { type: 'date', label: 'End Date' },
              { type: 'number', label: 'Duration' },
              { type: 'number', label: 'Percent Complete' },
              { type: 'string', label: 'Dependencies' },
            ],
            [
              'Research',
              'DC Setup',
              new Date(2015, 0, 1),
              new Date(2015, 0, 5),
              null,
              100,
              null,
            ],
            [
              'Write',
              'Migration',
              null,
              new Date(2015, 0, 9),
              3 * 24 * 60 * 60 * 1000,
              25,
              'Research,Outline',
            ],
            [
              'Cite',
              'Create bibliography',
              null,
              new Date(2015, 0, 7),
              1 * 24 * 60 * 60 * 1000,
              20,
              'Research',
            ],
            [
              'Complete',
              'Hand in paper',
              null,
              new Date(2015, 0, 10),
              1 * 24 * 60 * 60 * 1000,
              0,
              'Cite,Write',
            ],
            [
              'Outline',
              'Outline paper',
              null,
              new Date(2015, 0, 6),
              1 * 24 * 60 * 60 * 1000,
              100,
              'Research',
            ],
          ]}
          rootProps={{ 'data-testid': '1' }}
        />
      }
      {charttype == 'calendar' &&

        <Chart
          width="100%"
          height={200}
          chartType="Calendar"
          loader={<div>Loading Chart</div>}
          data={[
            [{ type: 'date', id: 'Date' }, { type: 'number', id: 'Won/Loss' }],
            [new Date(2022, 0, 4), 1],
            [new Date(2022, 0, 5), 3],
            [new Date(2022, 0, 7), -1],
            [new Date(2022, 0, 8), 2],
            [new Date(2022, 0, 12), -1],
            [new Date(2022, 0, 13), 1],
            [new Date(2022, 0, 15), 1],
            [new Date(2022, 0, 16), -4],
          ]}
          options={{
            title: 'My Visits & Schedule',
          }}
          rootProps={{ 'data-testid': '1' }}
        />

        // <Chart
        //   width={1000}
        //   height={200}
        //   chartType="Calendar"
        //   loader={<div>Loading Chart</div>}
        //   data={[
        //     [{ type: 'date', id: 'Date' }, { type: 'number', id: 'Won/Loss' }],
        //     [new Date(2012, 3, 13), 37032],
        //     [new Date(2012, 3, 14), 38024],
        //     [new Date(2012, 3, 15), 38024],
        //     [new Date(2012, 3, 16), 38108],
        //     [new Date(2012, 3, 17), 38229]
        //   ]}
        //   options={{
        //     title: 'Liquidity',
        //   }}
        //   rootProps={{ 'data-testid': '1' }}
        // />

        // <Chart
        //   width={1000}
        //   height={200}
        //   chartType="Calendar"
        //   loader={<div>Loading Chart</div>}
        //   data={[
        //     [{ type: 'date', id: 'Date' }, { type: 'number', id: 'Won/Loss' }],
        //     [new Date(2012, 3, 13), 12],
        //     [new Date(2012, 3, 14), 38024],
        //     [new Date(2012, 3, 15), 38024],
        //     [new Date(2012, 3, 16), 38108],
        //     [new Date(2012, 3, 17), 38229]
        //   ]}
        //   options={{
        //     title: 'Daily Bank Position',
        //     colorAxis: {
        //       colors: ['green', 'red']
        //     }
        //   }}
        //   rootProps={{ 'data-testid': '1' }}
        // /> 
      }


    </div>
  );
}


export default GoogleChart;